/**
 * Created by Claude on 09.04.2026
 */

const LandmarkSelectItem = cc.Node.extend({
    ctor: function (config) {
        this._super();
        this.config = config;
        this.selected = false;
        const styles = cleverapps.styles.LandmarkSelectItem;

        this.setContentSize2(styles.unit_background);
        this.setBackground(bundles.landmarkselectwindow.frames.background);

        const text = cleverapps.unitsLibrary.getUnitName(config);
        const title = this.title = cleverapps.UI.generateOnlyText(text, cleverapps.styles.FONTS.LANDMARK_SELECT_TITLE_TEXT);
        cleverapps.UI.fitToBox(title, styles.title);
        title.setAlignment(styles.title);
        this.addChild(title);

        const unitView = this.unitView = UnitView.getUnitImage(config, { preferStatic: true, useLibraryAnchors: true });
        cleverapps.UI.fitToBox(this.unitView, styles.unit);
        unitView.setAlignment(styles.unit);
        this.unitView.setCascadeOpacityEnabledRecursively(true);
        this.addChild(unitView);
        unitView.setOpacity(150);
    },

    setBackground: function (background) {
        if (this.bg) {
            this.bg.removeFromParent();
            delete this.bg;
        }
        const bg = this.bg = cleverapps.UI.createScale9Sprite(background, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize2(this.getContentSize());
        bg.setAlignment(this.width / 2, this.height / 2);
        this.addChild(bg, -1);
    },

    addButton: function () {
        const styles = cleverapps.styles.LandmarkSelectItem;

        this.removeButton();
        const content = new cc.Node();
        const icon = new cc.Sprite(bundles.landmarkselectwindow.frames.magnifier_icon);
        content.addChild(icon);

        const button = this.button = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.small_button_blue,
            onClicked: this.findButtonClick.bind(this),
            content,
            width: styles.button.width,
            height: styles.button.height
        });
        this.addChild(button);
        button.setAlignment(styles.button);
    },

    removeButton: function () {
        if (this.button) {
            this.button.removeFromParent();
        }
    },

    findButtonClick: function () {
        if (typeof StickersBook2 !== "undefined" && StickersBook2.isMainPrizeLandmark(this.config)) {
            StickersBook2.openBookWindow();
            return;
        }

        if (Map2dLocation.currentLocation.landmarks.isOnMap(this.config)) {
            cleverapps.focusManager.currentWindow().close();
            Map2dScroller.currentScroller.cancelZoomOut();
            UnitLocator.find(Map2d.OPEN_UNIT, this.config, { allowScrollWithFocus: true });
            return;
        }

        cleverapps.focusManager.display({
            focus: "AchievementExplanationWindow",
            stack: true,
            action: (f) => {
                new AchievementExplanationWindow(this.config);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    setCheckmark: function () {
        if (this.selected && !this.checkmark) {
            this.checkmark = new cc.Sprite(bundles.landmarkselectwindow.frames.checkmark);
            this.checkmark.setAlignment(cleverapps.styles.LandmarkSelectItem.checkmark);
            this.addChild(this.checkmark);
        } else if (!this.selected && this.checkmark) {
            this.checkmark.removeFromParent();
            delete this.checkmark;
        }
    },

    canDeploy: function () {
        const landmarks = Map2dLocation.currentLocation.landmarks;
        return landmarks && landmarks.canDeploy(this.config);
    },

    canHint: function () {
        return !this.canDeploy() && !this.selected;
    },

    updateState: function () {
        if (this.getDeployed()) {
            this.setOpened(true);
            this.setSelected(true);
        } else {
            this.setOpened(this.canDeploy());
            this.setSelected(false);
        }

        if (this.canHint()) {
            this.addButton();
        } else {
            this.removeButton();
        }
    },

    getDeployed: function () {
        const landmarks = Map2dLocation.currentLocation.landmarks;
        if (!landmarks) {
            return false;
        }
        return landmarks.listDeployed().find((unit) => Unit.IsApplicable(this.config, unit));
    },

    setOpened: function (opened) {
        this.setBackground(opened ? bundles.landmarkselectwindow.frames.background_selected : bundles.landmarkselectwindow.frames.background);
        this.unitView.setOpacity(opened ? 255 : 150);
    },

    setSelected: function (state) {
        if (state === this.selected) {
            return;
        }

        this.selected = state;
        this.setCheckmark();
        this.setScale(state ? 1.1 : 1.0);
        this.baseScale = state ? 1.1 : 1.0;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LANDMARK_SELECT_TITLE_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    }
});

cleverapps.styles.LandmarkSelectItem = {
    title: {
        x: { align: "center" },
        y: { align: "center", dy: 95 },

        width: 200
    },

    unit: {
        x: { align: "center" },
        y: { align: "center", dy: -15 },

        width: 160,
        height: 160
    },

    unit_background: {
        width: 250,
        height: 260
    },

    checkmark: {
        x: { align: "right", dx: -20 },
        y: { align: "bottom" }
    },

    button: {
        x: { align: "right", dx: -11 },
        y: { align: "bottom", dy: 15 },
        width: 70,
        height: 70,
        content: {
            width: 50,
            height: 70
        }
    }
};
